import { INITIALIZE_DATA, RESET, SET_LOADING, SET_SERVER_ERROR } from '@Actions/cardsGatewayIssuingModalActions';
export const defaultState = {
    loading: 'body',
    serverError: null,
    parentCardOptions: [],
    parentCardsById: {},
    categoryOptions: [],
    expenseTagsBucketsForUser: [],
    issuingDetailsOriginalValues: null
};
const handleInitializeData = (state = defaultState, action) => {
    let parentCardOptions = state.parentCardOptions;
    let parentCardsById = state.parentCardsById;
    if (action.parentCardOptions) {
        parentCardOptions = action.parentCardOptions.map((card) => (Object.assign(Object.assign({}, card), { displayName: card.name ? `${card.name} ${card.last4}` : card.last4 })));
        parentCardsById = parentCardOptions.reduce((accumulator, current) => {
            accumulator[current.id] = current;
            return accumulator;
        }, {});
    }
    return Object.assign(Object.assign({}, state), { loading: false, parentCardOptions,
        parentCardsById, issuingDetailsOriginalValues: action.issuingDetailsOriginalValues });
};
export function cardsGatewayIssuingModalReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_LOADING:
            return Object.assign(Object.assign({}, state), { loading: action.loading });
        case INITIALIZE_DATA:
            return handleInitializeData(state, action);
        case SET_SERVER_ERROR:
            return Object.assign(Object.assign({}, state), { serverError: action.message });
        case RESET:
            return Object.assign({}, defaultState);
        default:
            return state;
    }
}
